import PropTypes from "prop-types";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";

// Create the Portal DIV for drag and drop
const portal = document.createElement("div");
portal.setAttribute("id", "ql-portal");
if (!document.body) {
  throw new Error("body not ready for portal creation!");
}
document.body.appendChild(portal);

// Styling
const colors = {
  background: "white",
  staticbg: "lightgray",
  draggingbg: "whitesmoke",
  border: "lightgray",
  staticborder: "darkgray",
  draggingborder: "black",
};

const SimpleQuickListItem = styled.div`
  padding: var(--padding-5px);
  margin-bottom: var(--margin-5px);
  background-color: ${props => props.inPortal ? colors.draggingbg : props.isEditable ? colors.background : colors.staticbg};
  border: 1px solid ${props => props.inPortal ? colors.draggingborder : props.isEditable ? colors.border : colors.staticborder};
  position: relative;
  overflow: hidden;
`;

class QuickListItem extends Component {
  render() {
    const { provided, snapshot, item } = this.props;
    if (!item) return null;

    const usePortal = snapshot.isDragging;

    // Need to check as this component is reused for columns in quick list edit
    const isQuicklist = Object.keys(item).includes("quickListCode");

    const child = (
      <SimpleQuickListItem
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        inPortal={usePortal}
        isEditable={isQuicklist ? item.isEditable : true}
      >
        {item.name}
      </SimpleQuickListItem>
    );

    if (!usePortal) {
      return child;
    }

    // if dragging - put the item in a portal
    return ReactDOM.createPortal(child, document.getElementById("ql-portal"));
  }
}

QuickListItem.propTypes = {
  provided: PropTypes.object.isRequired,
  snapshot: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
};
export default QuickListItem;